import React from "react";

import TrustedHealthcareSection from "../components/TrustedHealthcareSection";
import ClientsSection from "../components/ClientsSection";
import TestimonialSection from "../components/TestimonialSection";
import MarqueeSection from "../components/MarqueeSection";
import ProcessSection from "../components/ProcessSection";

const MainPage = () => {
  return (
    <>
      <TrustedHealthcareSection />
      <ClientsSection />
      <ProcessSection/>
      <TestimonialSection />
      <MarqueeSection />
    </>
  );
};

export default MainPage;
